import React from 'react';
import { useHistory, Link, useLocation } from 'react-router-dom';
import Map from './Map';
import '../styles/Footer.css';

const Footer = () => {
  const history = useHistory();
  const location = useLocation();

  const scrollToSection = (sectionId, path) => {
    const scrollWithOffset = (element) => {
      const navbarHeight = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    };

    if (location.pathname !== path) {
      history.push(path);
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          scrollWithOffset(element);
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        scrollWithOffset(element);
      }
    }
  };

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-section">
          <h4>제트플로우 (ZFLOW)</h4>
          <div className="footer-address-section">
            <div className="footer-address-info">
              <p className="footer-address-text">
                <i className="fas fa-envelope"></i>
                hj.kim@zflow.co.kr
              </p>
              <p className="footer-address-text">
                <i className="fas fa-map-marker-alt"></i>
                경기도 안양시 동안구 시민대로 109번길 29, 1804호
                <br />
                (호계동, 에이스하이테크시티 범계)
              </p>
            </div>
            <Map />
          </div>
        </div>

        <div className="footer-nav-grid">
          <div className="footer-nav-section">
            <h5>회사소개</h5>
            <ul>
              <li>
                <a
                  href="#about-intro"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('about-intro', '/about');
                  }}
                >
                  회사 소개
                </a>
              </li>
              <li>
                <a
                  href="#about-values"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('about-values', '/about');
                  }}
                >
                  핵심 가치
                </a>
              </li>
              <li>
                <a
                  href="#about-history"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('about-history', '/about');
                  }}
                >
                  연혁
                </a>
              </li>
              <li>
                <a
                  href="#about-team"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('about-team', '/about');
                  }}
                >
                  경영진 소개
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-nav-section">
            <h5>기술</h5>
            <ul>
              <li>
                <Link to="/technology" onClick={() => scrollToSection('tech-intro', '/technology')}>
                  기술력 소개
                </Link>
              </li>
              <li>
                <Link to="/technology" onClick={() => scrollToSection('tech-status', '/technology')}>
                  핵심 기술 및 서비스
                </Link>
              </li>
              <li>
                <Link to="/technology" onClick={() => scrollToSection('patent-copyright', '/technology')}>
                  특허 및 저작권
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-nav-section">
            <h5>서비스</h5>
            <ul>
              <li>
                <Link to="/products">전체 서비스</Link>
              </li>
              <li>
                <Link to="/products/pig-farm">스마트 돼지 농장 관리 시스템</Link>
              </li>
              <li>
                <Link to="/products/wasp-system">AI 말벌 퇴치 시스템</Link>
              </li>
              <li>
                <Link to="/products/aas">AAS</Link>
              </li>
              <li>
                <Link to="/products/ai">AI</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-copyright">© 2024 ZFlow. All rights reserved.</div>
    </footer>
  );
};

export default Footer;
